import { SvgIconTypeMap } from '@material-ui/core'
import { OverridableComponent } from '@material-ui/core/OverridableComponent'
import clsx from 'clsx'
import { ExtendedSvgIcon } from 'components/ActionBar'
import React from 'react'

const InsertPillIcon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> = (
    props: any
) => (
    <ExtendedSvgIcon
        width="20"
        height="12"
        viewBox="0 0 20 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        className={clsx('InsertPillIcon', props.className)}
    >
        <rect
            x="1"
            y="1"
            width="18"
            height="10"
            rx="5"
            stroke="#314959"
            stroke-width="2"
        />
    </ExtendedSvgIcon>
)

export default InsertPillIcon
